/**
 * The FoodEshow brand package — frontend config.
 * Apply with: scripts/apply-brand thefoodeshow
 */
module.exports = {
  name: "The FoodEshow",
  fullName: "The FoodEshow",
  tagline: "Connecting the F&B Professionals",
  shortName: "The FoodEshow",

  colors: {
    primary: {
      50: "#f4f9f4",
      100: "#e5f3e5",
      200: "#cce6cc",
      300: "#99cc99",
      400: "#74b474",
      500: "#509750",
      600: "#3e7b3e",
      700: "#336234",
      800: "#2c4f2d",
      900: "#264127",
      950: "#112212",
    },
  },

  fontFamily: "'Cairo', 'Roboto', sans-serif",

  logo: "/assets/images/logo.png",
  favicon: "/icon.png",

  supportEmail: "support@thefoodeshow.com",
  defaultLanguage: "en",
  rtl: false,

  pwaName: "The FoodEshow",
  pwaThemeColor: "#99cc99",

  // ─── Auth & Onboarding Page Images ───────────────────────────────────────────
  // Paths are relative to /public — place files in frontend/public/assets/images/backgrounds/
  // Recommended sizes:
  //   loginBanner / registerBanner : 1920×1080 px JPG  (full-height right panel)
  //   onboardingBg                 : 1920×1080 px JPG  (full-height left panel)
  images: {
    loginBanner:    'assets/images/backgrounds/login-bg.jpg',
    registerBanner: 'assets/images/backgrounds/login-bg.jpg',
    onboardingBg:   'assets/images/backgrounds/login-bg-1.jpg',
  },

  // Background color of the decorative side panel on the login page.
  // Supports any valid CSS color: hex, rgb(), hsl().
  // The register & onboarding panels use primary-900/primary-600 gradient (auto from brand color).
  authPanelColor: '#22154a',

  // ─── Navigation ─────────────────────────────────────────────────────────────
  navigation: {
    links: {
      home: { enabled: true },
      "my-eshow": { enabled: true, label: "My Eshow" },
      companies: { enabled: true, label: "Exporters" },
      "vib-buyers": { enabled: true, label: "VIB Buyers" },
      community: { enabled: true },
      speakers: { enabled: false },
      agenda: { enabled: true },
      products: { enabled: true },
      services: { enabled: true },
      "help-desk": { enabled: false },
      "on-demand": { enabled: true },
    },
    custom: [
      // {
      //   key: "morocco-now",
      //   label: "Morocco Now",
      //   url: "https://morocconow.com",
      //   icon: "solar:calendar-linear",
      //   target: "_blank",
      //   roles: [
      //     "admin",
      //     "exhibitor",
      //     "buyer",
      //     "speaker",
      //     "sponsor",
      //     "attendee",
      //   ],
      // },
    ],
  },
};
